import React, { useState, useEffect } from 'react'
import { Modal, Table, Button } from 'antd'
import { useBaozhangdanListQuery } from '../../store/DianShangYeWuApi'
import dayjs from 'dayjs'
import StateTag from '../../cpn/StateTag'
import ReportCheck from '../../document/report/ReportCheck'
import { exportTableToPDF } from '../../cpn/PDFViewer'
import classes from '../statistic.module.css'

const stateMap = { '1': '待提交', '2': '待审批', '3': '审批中', '4': '已驳回', '5': '已结束', '6': '已结束' }
function ClientGroupDetails(props) {
    const [open, setOpen] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const {data,isSuccess} = useBaozhangdanListQuery({
        dsbzd_qy_id:props.qy_id,
        dsbzd_date_end_range:[props.date_s,props.date_e],
        dsbzd_kh_id:props.kh_id,
    }, { refetchOnMountOrArgChange: true,skip:!open});
    const columns = [
        {
            title: '团队名称',
            dataIndex: 'dsbzd_name',
            key: 'dsbzd_name',
            render: (_, record) => <ReportCheck 
                                        dsbzd_id={record.dsbzd_id} 
                                        dsbzd_name={record.dsbzd_name} 
                                        yh_id={props.yh_id}  
                                        yh_name={props.yh_name} 
                                        qy_id={props.qy_id} 
                                        qy_name={props.qy_name} 
                                        spjdList={props.spjdList} 
                                        dsbzd_ctime={record.dsbzd_ctime} 
                                        dsbzd_state={record.dsbzd_state}
                                        dsbzd_state_time={record.dsbzd_state_time} 
                                        dsbzd_uid={record.dsbzd_uid}
                                        listType='submitted'
                                    />
        },
        {
            title: '起止日期',
            dataIndex: 'dsbzd_date_start',
            key: 'dsbzd_date_start',
            render: (text, record) => <span>{dayjs(record.dsbzd_date).format('YYYY-MM-DD')} - {dayjs(record.dsbzd_date_end).format('YYYY-MM-DD')}</span>
        },
        {
            title: '状态',
            dataIndex: 'dsbzd_state',
            key: 'dsbzd_state',
            render: (text, record) => <StateTag state={record.dsbzd_state} />
        },
        {
            title: '收入',
            dataIndex: 'ddsr_amount',
            key: 'ddsr_amount',
        },
        {
            title: '支出',
            dataIndex: 'ddzc_amount',
            key: 'ddzc_amount',
        },
        {
            title: '费用',
            dataIndex: 'fy_amount',
            key: 'fy_amount',
        },
        {
            title: '利润',
            dataIndex: 'd_profit',
            key: 'd_profit',
        },        
        {
            title: '利润率',
            key: 'd_profit_rate',
            render: (text, record) => {
                if(+record.ddsr_amount === 0){
                    return '';
                }else{
                    return Number((record.ddsr_amount - record.ddzc_amount - record.fy_amount) / record.ddsr_amount * 100).toFixed(2) + '%';
                }
            },
        },        
    ]
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const arr = (data.Result || []).map((item) => {
                    const ddsr_amount = (item.ddsr_list || []).reduce((sum, row) => sum + (parseFloat(row.ddsr_amount) || 0), 0);
                    const ddzc_amount = (item.ddzc_list || []).reduce((sum, row) => sum + (parseFloat(row.ddzc_amount) || 0), 0);
                    const fy_amount = (item.fy_list || []).reduce((sum, row) => sum + (parseFloat(row.fy_amount) || 0), 0);
                    return {
                        ...item,
                        ddsr_amount,
                        ddzc_amount,
                        fy_amount,
                        d_profit: Number(ddsr_amount - ddzc_amount - fy_amount).toFixed(2),
                    };
                })
                setDataSource(arr.sort((a, b) => new Date(a.dsbzd_date) - new Date(b.dsbzd_date)));
            }
        }else{
            setDataSource([]);
        }
    }, [data,isSuccess]);

    const handleExportPDF = async () => {
        const headers = ['团队名称', '起止日期', '状态', '收入', '支出', '费用', '利润', '利润率'];
        const rows = dataSource.map(row => [
            row.dsbzd_name || '',
            `${dayjs(row.dsbzd_date).format('YYYY-MM-DD')} - ${dayjs(row.dsbzd_date_end).format('YYYY-MM-DD')}`,
            stateMap[String(row.dsbzd_state || '1')] || '未知',
            Number(row.ddsr_amount || 0).toFixed(2),
            Number(row.ddzc_amount || 0).toFixed(2),
            Number(row.fy_amount || 0).toFixed(2),
            String(row.d_profit || 0),
            row.ddsr_amount === 0 ? '' : Number((row.ddsr_amount - row.ddzc_amount - row.fy_amount) / row.ddsr_amount * 100).toFixed(2) + '%',
        ]);
        const totalRow = [
            '合计',
            '',
            '',
            Number(dataSource.reduce((s, r) => s + Number(r.ddsr_amount || 0), 0)).toFixed(2),
            Number(dataSource.reduce((s, r) => s + Number(r.ddzc_amount || 0), 0)).toFixed(2),
            Number(dataSource.reduce((s, r) => s + Number(r.fy_amount || 0), 0)).toFixed(2),
            Number(dataSource.reduce((s, r) => s + Number(r.d_profit || 0), 0)).toFixed(2),
            dataSource.reduce((s, r) => s + Number(r.ddsr_amount || 0), 0) > 0
                ? Number((dataSource.reduce((s, r) => s + Number(r.ddsr_amount || 0), 0) - dataSource.reduce((s, r) => s + Number(r.ddzc_amount || 0), 0) - dataSource.reduce((s, r) => s + Number(r.fy_amount || 0), 0)) / dataSource.reduce((s, r) => s + Number(r.ddsr_amount || 0), 0) * 100).toFixed(2) + '%'
                : '',
        ];
        await exportTableToPDF({
            title: `客户：${props.kh_name}，${dayjs(props.date_s).format('YYYY-MM-DD')} 至 ${dayjs(props.date_e).format('YYYY-MM-DD')}的团队明细`,
            headers,
            rows: [...rows, totalRow],
            filename: `客户${props.kh_name}_团队明细_${dayjs().format('YYYYMMDDHHmm')}.pdf`,
        });
    };

    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                {props.kh_name}
            </a>
            <Modal
                title={`客户：${props.kh_name}，${dayjs(props.date_s).format('YYYY-MM-DD')} 至 ${dayjs(props.date_e).format('YYYY-MM-DD')}的团队明细`}
                open={open}
                onCancel={() => {setOpen(false)}}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Button type="primary" onClick={handleExportPDF} disabled={!dataSource.length}>
                            导出PDF
                        </Button>
                    </div>
                }
                width={1200}
            >
                <Table 
                    dataSource={dataSource} 
                    columns={columns} 
                    bordered 
                    className={classes.customTable}
                    size='small' 
                    pagination={{
                        showSizeChanger:true,
                        defaultPageSize:50,
                        showTotal:(total) => `共${total}条`,
                    }}
                    rowKey="dsbzd_id"
                    summary={pageData => {
                        const total_ddsr_amount = pageData.reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0);
                        const total_ddzc_amount = pageData.reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0);
                        const total_fy_amount = pageData.reduce((sum, row) => sum + Number(row.fy_amount || 0), 0);
                        const total_d_profit = Number(total_ddsr_amount - total_ddzc_amount - total_fy_amount).toFixed(2);
                        const total_d_profit_rate = total_ddsr_amount > 0 ? Number((total_ddsr_amount - total_ddzc_amount - total_fy_amount) / total_ddsr_amount * 100).toFixed(2) : 0;
                        return (
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>合计：</Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>
                                    <span>￥{Number(total_ddsr_amount).toLocaleString('zh-CN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>
                                    <span>￥{Number(total_ddzc_amount).toLocaleString('zh-CN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={5}>
                                    <span>￥{Number(total_fy_amount).toLocaleString('zh-CN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={6} colSpan={1}>
                                    <span>￥{Number(total_d_profit).toLocaleString('zh-CN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={7} colSpan={1}>
                                    <span>{Number(total_d_profit_rate).toFixed(2)}%</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={8} colSpan={columns.length - 2} />
                            </Table.Summary.Row>
                        );
                    }}
                />
            </Modal>
        </>
  )
}

export default ClientGroupDetails
